module.exports = __webpack_public_path__ + "static/anna_prieto-c9c7a17de8a514ead96f8a9776a589ad.jpg";